export const validateProperties = (obj: any, requiredProps: string[]): void => {
    for (const prop of requiredProps) {
        if (!(prop in obj)) {
            console.error(`Property ${prop} missing in object`);
            throw new Error(`Property ${prop} missing in object`);
        }
    }
};
